// import React from 'react';

// const PlayNextIcon = (props: React.SVGProps<SVGSVGElement>) => (
//   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
//     <path d="M8 7L14 12L8 17V7Z" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />

//     <path d="M16 7V17" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
//   </svg>
// );

// export default PlayNextIcon;

// import React from 'react';

// const PlayNextIcon = (props: React.SVGProps<SVGSVGElement>) => (
//   <svg
//     width="24"
//     height="24"
//     viewBox="0 0 24 24"
//     color="lightgrey"
//     fill="lightgrey"
//     xmlns="http://www.w3.org/2000/svg"
//     {...props}
//   >
//     <path d="M7 6L15 12L7 18V6Z" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />

//     <path d="M17 6V18" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
//   </svg>
// );

// export default PlayNextIcon;

import React from 'react';

const PlayNextIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g>
      <path d="M6 5L13 10L6 15V5Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />

      <path d="M15 5V15" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
  </svg>
);

export default PlayNextIcon;
